export const getCompanyName = (companiesArray, companyId) => {
  try {
    const res = companiesArray?.find((x) => x.id === companyId)
    return res.name
  } catch (error) {
    return 'no-data'
  }
}